/* <j-page>
        <div slot="search" @keydown.enter="searchEvent">
            <j-page-search title="时间">
                <j-date-range :start.sync="query.starttime" :end.sync="query.endtime"/>
            </j-page-search>
            <j-page-search title="标题">
                <el-input v-model.trim="query.title" placeholder="请输入" clearable />
            </j-page-search>
            <j-page-search title="角色">
                <el-select v-model="query.xxx" placeholder="请选择" clearable filterable>
                    <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </j-page-search>
            <div class="search-button-left">
              <el-button type="primary" class="common-button-search" @click="searchEvent">查询</el-button>
              <el-button type="info" @click="resetEvent">重置</el-button>
            </div>
            <div class="search-button-right">
              <el-button type="warning">新增</el-button>
            </div>
        </div>
        <div slot="table">
            <el-table v-loading="tableLoading" :data="tableData" @selection-change="tableSelectionChange" height="100%" stripe>
                <el-table-column type="selection" align="center" width="50" />
                <el-table-column type="index" label="序号" align="center" width="50" />
                <el-table-column prop="title" label="所属区域" align="center" show-overflow-tooltip />
                <el-table-column label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button @click.stop="detialEvent(scope.row)" type="text" class="common-button-add">权限</el-button>
                        <el-button @click.stop="detialEvent(scope.row)" type="text" class="common-button-detail">详情</el-button>
                        <el-button @click.stop="editEvent(scope.row)" type="text" class="common-button-edit">编辑</el-button>
                        <el-button @click.stop="delEvent(scope.row)" type="text" class="common-button-del" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="pagination" v-show="query.total > query.limit">分页需要使用分页混入<el-pagination/></div>
    </j-page> */

import JPage from "../JPage";
import JPageSearch from "../components/JPageSearch";
import JDateRange from "../../JDateRange/JDateRange";
import JDictionary from "../../JDictionary/JDictionary";
import JGridCtrl from "../../JGridCtrl/JGridCtrl";
import JColour from "../../JColour/JColour";
import JSensitive from "../../JSensitive/JSensitive";
import JUpload from "../../JUpload/JUpload";
import JIpInput from "../../JIpInput/JIpInput";
import JLinkAddress from "../../JLinkAddress/JLinkAddress";
import JLinkInput from "../../JLinkInput/JLinkInput";
import JInput from "../../JInput/JInput";
import JFile from "../../JFile/JFile";
export default {
  components: {
    JPage,
    JPageSearch,
    JInput,
    JDateRange,
    JDictionary,
    JGridCtrl,
    JColour,
    JSensitive,
    JUpload,
    JIpInput,
    JLinkAddress,
    JLinkInput,
    JFile
  },
  data () {
    return {
      submitLoad: false,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      query: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  methods: {
    async getDetailMetaData (api) {
      const { data } = await this.$http.get(api)
      if (data.status !== 'yes') return {}
      return data.data
    },
    tableSelectionChange (selection) {
      this.tableSelection = selection
    },
    async exportEvent () {
      const { data } = await this.$http.request({
        method: 'get',
        url: `/api/export`,
        params: { ...this.query, type: this.type },
        responseType: 'arraybuffer',
        notProcessed: true // axios不统一处理请求返回操作
      })
      let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', '导出结果')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) // 下载完成移除元素
      window.URL.revokeObjectURL(url) // 释放掉blob对象
    },
    async load () {
      this.tableLoading = true
      const { data } = await this.$http.get(`/api/list`, {
        params: this.query
      }).finally(() => {
        this.tableLoading = false
      })
      if (data.status !== 'yes') return this.$message.warning(data.msg || data.message || `接口异常`)
      this.tableData = data.data.data
      this.query.total = data.data.total
      this.tableLoading = false
    },
    searchEvent () {
      this.query.page = 1
      this.load && this.load()
    },
    resetEvent () {
      // 重置query对象
      this.query = { ...this.$options.data().query }
      this.load && this.load()
    },
    delEvent (row) {
      this.$confirm('您确认要删除当前记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request({ method: 'delete', url: `/api/categorys/${row.id}`})
          .then((res) => {
            if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
            this.pageUpdate(this.query)
            this.$message.success('删除成功')
            this.load && this.load()
          })
      })
    },
    pageUpdate (queryParams) { // 当页面仅有最后一条记录时，删除该记录，需要请求上一页数据
      const query = queryParams || this.query || { page: 1, limit: 10, total: 0 }
      let curPage = Math.ceil((query.total - 1) / query.limit) || 1
      if (query.page > curPage) query.page = curPage
    }
  }
}
